import { render, staticRenderFns } from "./RelacionFacturas.vue?vue&type=template&id=0cf4e671&scoped=true"
import script from "./RelacionFacturas.vue?vue&type=script&lang=js"
export * from "./RelacionFacturas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf4e671",
  null
  
)

export default component.exports